import { render } from "./KilimoEye.vue?vue&type=template&id=2d2e3f55&scoped=true"
import script from "./KilimoEye.vue?vue&type=script&lang=js"
export * from "./KilimoEye.vue?vue&type=script&lang=js"

import "./KilimoEye.vue?vue&type=style&index=0&id=2d2e3f55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2e3f55"]])

export default __exports__